import Navbar from "../nav-bar/Navbar";
import FloatingSocial from "../floating-social/FloatingSocial";
import Footer from "../footer/Footer";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  return (
    <>
      <Navbar />
      <FloatingSocial />
      <Outlet />
      <Footer />
    </>
  );
};

export default MainLayout;
